module.exports = __webpack_public_path__ + "img/yd_icon.e7a6ba7b.png";